import { Injectable } from '@angular/core';
import {RestHttpService} from "@catcore/services/rest-http.service";
import {Restangular} from "ngx-restangular";
import {Observable} from "rxjs/Observable";

@Injectable()
export class FeatureGgwDevicesService extends RestHttpService<any> {

  constructor(service: Restangular) {
    super('feature-ggw-devices', service);
  }

  create(item: any): Observable<any> {
    return this.queryAll()
      .post({
          feature: item.feature._links.self.href,
          model: item.ggwDevice._links.self.href,
          unit_type: item.featureUnit ? item.featureUnit._links.self.href : undefined,
          name: item.name,
      })
      .map((createdFeature) => {
          return createdFeature;
      });
  }

  /**
   * Updates the feature unit from the underlying model.
   * @param id
   */
  updateFromModel(id: any) {
    return this.getRawSubresource(id, 'update');
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/ggw-device/services/feature-ggw-devices.service.ts